import { render, staticRenderFns } from "./PreviewBlockRevision.vue?vue&type=template&id=1448a544&"
import script from "./PreviewBlockRevision.vue?vue&type=script&lang=js&"
export * from "./PreviewBlockRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports